
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.333c-2.933 0-5.333 2.4-5.333 5.333 0 3.6 4.667 7.667 4.867 7.867.133.067.333.133.466.133.134 0 .334-.066.467-.133.2-.2 4.867-4.267 4.867-7.867 0-2.933-2.4-5.333-5.334-5.333zm0 11.8c-1.4-1.333-4-4.2-4-6.467 0-2.2 1.8-4 4-4s4 1.8 4 4-2.6 5.134-4 6.467zM8 4a2.675 2.675 0 00-2.666 2.666c0 1.467 1.2 2.667 2.666 2.667 1.467 0 2.667-1.2 2.667-2.667C10.667 5.2 9.467 4 8 4zm0 4c-.733 0-1.333-.6-1.333-1.334 0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333C9.334 7.4 8.734 8 8 8z","fill":"#A0AEC0"}})])
          )
        }
      }
    